<template>
	<div class="game">
		<div class="titleBox">
			<img src="../../assets/tennis/WechatIMG797.png"/>
			<span>五星网球分级电视挑战赛</span>
		</div>
		<div>
			<div class="game1">
				<!-- <div class="text01">每步科技</div> -->
				<div class="text02" v-if="scores[0].name">{{ scores[0].name }}</div>
				<div class="text03">
					<div class="ball" v-if="scores[0].serve == 1"></div>
					<div class="text03-01">{{ scores[0].countscore }}</div>
					<div class="text03-02">{{ scores[0].score }}</div>
				</div>
			</div>
			<div class="game1">
				<!-- <div class="text01">每步科技每步科技每步科技每步科技</div> -->
				<div class="text02" v-if="scores[1].name">{{ scores[1].name }}</div>
				<div class="text03">
					<div class="ball" v-if="scores[1].serve == 1"></div>
					<div class="text03-01">{{ scores[1].countscore }}</div>
					<div class="text03-02">{{ scores[1].score }}</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'game',
	data(){
		return {
			scores: [{
				name: '--',
				score: 0,
				countscore: 0,
				serve: 0,
			},{
				name: '--',
				score: 0,
				countscore: 0,
				serve: 0,
			}],
			timer: null,
		}
	},
	mounted() {
		this.matchid = this.$route.query.matchid
		this.trackid = this.$route.query.trackid
		var _this = this
		if(this.$route.query.groupnum){
			// console.log('opopo')
			this.getData();
			this.timer = setInterval(() => {
				_this.getData();
			}, 3000)
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
	methods: {
	
		getData(){
			let _this = this
			this.matchid = this.$route.query.matchid
			this.trackid = this.$route.query.trackid
			this.groupnum = this.$route.query.groupnum
			var data = {
				matchid: this.matchid,
				trackid: this.trackid,
				groupnum: this.groupnum
			}
			
			this.$api.tennis
				.getDataBoard(data)
				.then((res) => {
					if (res.status * 1 === 200) {
						// scores: [{
						// 	name: '--',
						// 	score: 0,
						// 	countscore: 0
						// },{
						// 	name: '--',
						// 	score: 0,
						// 	countscore: 0
						// }]
						// _this.scores = []
						_this.$set(_this.scores[0], 'name', res.data[0].name)
						if(res.data[0].scores.length == 0){
							_this.$set(_this.scores[0], 'score', 0)
						}else{
							if(res.data[0].scores[(res.data[0].scores.length - 1)].score == 45){
								_this.$set(_this.scores[0], 'score', 40)
							}else{
								_this.$set(_this.scores[0], 'score', res.data[0].scores[(res.data[0].scores.length - 1)].score)
							}
						}
						// _this.$set(_this.scores[0], 'score', res.data[0].scores.length == 0 ? 0 : res.data[0].scores[(res.data[0].scores.length - 1)].score)
						_this.$set(_this.scores[0], 'countscore', res.data[0].score)
						_this.$set(_this.scores[0], 'serve', res.data[0].scores.length == 0 ? 0 : res.data[0].scores[(res.data[0].scores.length - 1)].serve)
						_this.$set(_this.scores[1], 'name', res.data[1].name)
						
						// _this.$set(_this.scores[1], 'score', res.data[1].scores.length == 0 ? 0 : res.data[1].scores[(res.data[1].scores.length - 1)].score)
						if(res.data[1].scores.length == 0){
							_this.$set(_this.scores[1], 'score', 0)
						}else{
							if(res.data[1].scores[(res.data[1].scores.length - 1)].score == 45){
								_this.$set(_this.scores[1], 'score', 40)
							}else{
								_this.$set(_this.scores[1], 'score', res.data[1].scores[(res.data[1].scores.length - 1)].score)
							}
						}
						_this.$set(_this.scores[1], 'serve', res.data[1].scores.length == 0 ? 0 : res.data[1].scores[(res.data[1].scores.length - 1)].serve)
						_this.$set(_this.scores[1], 'countscore', res.data[1].score)
						console.log("rrr", _this.scores)
					}
					// this.$toast.clear();
				});
		}
	}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
